import React from "react";
import {
  Dialog,
  Spinner,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import { useState, useEffect } from "react";
// import { currentUserId } from "../../services/authService";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../services/firebase";
import { Base_Url } from "../../services/firebase";
import { noWrap } from "@fluentui/react";

function UpdateConfirmationDialog({
  isDeleteDialogOpen,
  setIsOpen,
  onCancelRSVPYes,
  text,
  event,
  checkRefundEligibility,
  userid,
}) {
  const [loading, setLoading] = React.useState(false);
  const [user] = useAuthState(auth);

  const refundDate = new Date(event.refundDate);
  const currentDate = new Date();

  console.log("Refund Date:", refundDate);
  console.log("Current Date:", currentDate);

  const diffInMs = refundDate - currentDate;
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  console.log("User info in dialog:", event);

  // Calculate refund eligibility
  const refundInfo = checkRefundEligibility
    ? checkRefundEligibility(event?.startDate, event?.refundDate)
    : { isEligible: false, days: 0, hours: 0, minutes: 0 };

  const handleUpdate = async () => {
    if (!userid || !event?.id) {
      console.warn("Missing userInfo or event id:", {
        userid,
        eventId: event?.id,
      });
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${Base_Url}/refundRSVP`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${user.accessToken}`,
          Accept: "application/json",
        },
        body: JSON.stringify({
          eventId: event.id,
          userId: userid,
        }),
      });

      if (!response.ok) {
        const errText = await response.text().catch(() => "");
        console.error("API error:", response.status, errText);
        return;
      }

      const data = await response.json().catch(() => null);
      console.log("API Response:", data);
      setIsOpen(false);
    } catch (error) {
      console.error("Error updating RSVP:", error);
    } finally {
      setLoading(false);
      onCancelRSVPYes();
    }
  };

  return (
    <Dialog
      open={isDeleteDialogOpen}
      onOpenChange={(e, data) => setIsOpen(data.open)}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Update {text}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: "16px" }}>
              Are you sure you want to update this {text}?
            </div>

            {event && (
              <div
                style={{
                  padding: "12px",
                  backgroundColor: refundInfo.isEligible
                    ? "#e6ffe6"
                    : "#ffe6e6",
                  borderRadius: "4px",
                  border: `1px solid ${refundInfo.isEligible ? "#4caf50" : "#f44336"
                    }`,
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    color: refundInfo.isEligible ? "#2e7d32" : "#c62828",
                    marginBottom: "4px",
                  }}
                >
                  {refundInfo.isEligible
                    ? "✓ Eligible for Refund"
                    : "✗ Not Eligible for Refund"}
                </div>
                <div style={{ fontSize: "14px", color: "#666" }}>
                  {/* {refundInfo.isEligible
                    ? `Event starts in ${refundInfo.days} days, ${refundInfo.hours} hours, and ${refundInfo.minutes} minutes.`
                    : null} */}
                  {refundInfo.isEligible
                    ? ` Eligible for Refund`
                    : diffInDays < 0
                      ? `Refund deadline passed by ${Math.abs(diffInDays)} days.`
                      : `Refund eligibility period: ${diffInDays} days.`}
                </div>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            {refundInfo.isEligible && (
              <Button
                appearance="secondary"
                onClick={onCancelRSVPYes}
                style={{ marginRight: "auto", whiteSpace: "nowrap" }}
              >
                Update & Skip Refund
              </Button>
            )}
            <Button
              appearance="primary"
              onClick={handleUpdate}
              style={{
                backgroundColor: "#E97451",
                color: "black",
                whiteSpace: "nowrap",
                position: "relative",
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="tiny" />
                </>
              ) : refundInfo.isEligible ? (
                "Update & Refund"
              ) : (
                "Update"
              )}
            </Button>
            <Button appearance="secondary" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default UpdateConfirmationDialog;
